/**
 * Dynamite override for the UGC landing-page headings.
 *
 * Realm 1 (SFRA) Dynamite spec: same metrics as Garage, but the title uses the
 * regular cut of AzoSans (`AzoSans-Regular` / weight 400) with no casing change.
 * Only the deltas live here; the shared metrics are in
 * theme/components/project/ugc-landing-page.js.
 */
export default {
    baseStyle: {
        title: {
            fontFamily: 'AzoSans',
            fontWeight: 'normal',
            textTransform: 'none'
        }
    }
}
